// @flow

import { withStyles } from '@material-ui/core/styles';
import React, { PureComponent } from 'react';
import type { Dispatch } from 'redux';

import { getRoomName } from '../../../base/conference';
import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { cancelWaitForOwner } from '../../actions.web';


/**
 * The type of the React {@code Component} props of {@link WaitForOwnerDialog}.
 */
type Props = {

    /**
     * Redux store dispatch method.
     */
    dispatch: Dispatch<any>,

    /**
     * Function to be invoked after click.
     */
    onAuthNow: ?Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    /**
     * Name for this conference room (Slug) eg: riwj-ekfy-dcql.
     */
     _getSlugName: String,
}

const styles = () => {
    return {
        waitingHost: {
            background: '#0F766E !important',
            borderRadius: '1.5rem !important',

            '&:hover': {
                background: '#178F9D !important'
            }
        }

    };
};

/**
 * Authentication message dialog for host confirmation.
 *
 * @returns {React$Element<any>}
 */
class WaitForOwnerDialog extends PureComponent<Props> {
    /**
     * Instantiates a new component.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this._onCancelWaitForOwner = this._onCancelWaitForOwner.bind(this);
        this._onIAmHost = this._onIAmHost.bind(this);
    }

    _onCancelWaitForOwner: () => void;

    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onCancelWaitForOwner() {
        const { dispatch } = this.props;

        dispatch(cancelWaitForOwner());
    }

    _onIAmHost: () => void;

    /**
     * Called when the OK button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onIAmHost() {
        const { onAuthNow } = this.props;

        onAuthNow && onAuthNow();
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const {
            classes,
            t
        } = this.props;

        const redirectUrl = `${config.hosts.tacnique_app_url}/interview/interviewer/validate?slug=${this.props._getSlugName}`;

        return (
            <Dialog
                cancelDisabled = { true }
                classes = { classes.waitingHost }
                disableBlanketClickDismiss = { true } 
                hideCloseIconButton = { true }
                isModal = { true }
                okKey = 'I am the interviewer'
                onCancel = { this._onCancelWaitForOwner }
                onSubmit = {() => { 
                    console.log("redirecting to tacnique app", redirectUrl)
                    window.location.href = redirectUrl; }}
                submitDisabled = { true }
                titleKey = ' Waiting for the interviewer ...'
                width = { 'small' }>
                <span>
                    The meeting has not started yet. Please wait for the interviewer to arrive.
                    {/* { t('dialog.WaitForHostMsg') } */}
                </span>
            </Dialog>
        );
    }
}


/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {

    return {
        _getSlugName: getRoomName(state)
    };
}

export default translate(connect(_mapStateToProps)(withStyles(styles)(WaitForOwnerDialog)));

